/**
 * Studio v2 — the theme registry (token-contract §5.3) + the legacy report-theme
 * alias map (§6.4) so old persisted `config.theme` values keep resolving with no
 * data migration.
 */
import { xavior } from './xavior.js';
import { boardroom } from './boardroom.js';
import { keynote } from './keynote.js';
import { editorial } from './editorial.js';
import { mono } from './mono.js';
export { xavior } from './xavior.js';
export { boardroom } from './boardroom.js';
export { keynote } from './keynote.js';
export { editorial } from './editorial.js';
export { mono } from './mono.js';
/** The static, code-defined built-in themes (never DB rows; token-contract §5.3). */
export const STUDIO_THEMES = {
    xavior,
    boardroom,
    keynote,
    editorial,
    mono,
};
/** Default flips from the report engine's `formal` to `xavior` (D16). */
export const DEFAULT_THEME_ID = 'xavior';
/**
 * Maps the 8 legacy `ReportTheme` ids onto the 5 new StudioTheme ids (§6.4 D16),
 * so `getStudioTheme` keeps resolving old persisted `config.theme` values with no
 * DB migration. `modern-dark` → `xavior` (its dark variant is an OPEN QUESTION,
 * token-contract §8 #1; until a `xavior-dark` ships it resolves to `xavior`).
 */
export const LEGACY_THEME_ALIASES = {
    formal: 'boardroom',
    'clean-minimal': 'mono',
    'editorial-warm': 'editorial',
    'modern-dark': 'xavior',
    newspaper: 'editorial',
    'bold-magazine': 'editorial',
    academic: 'editorial',
    playful: 'keynote',
};
/**
 * Resolve a theme by id. Consults the legacy alias map when an id isn't a
 * current `STUDIO_THEMES` key, then falls back to the default — preserving the
 * report engine's `getTheme`'s `?? DEFAULT` pattern verbatim.
 *
 * User-defined themes (the "+New theme" rail item) are merged in by the caller
 * via the resolver's `customThemes` input; this function covers only the static
 * built-in catalog + the legacy aliases.
 */
export function getStudioTheme(id) {
    if (id) {
        const direct = STUDIO_THEMES[id];
        if (direct)
            return direct;
        const aliased = LEGACY_THEME_ALIASES[id];
        if (aliased && STUDIO_THEMES[aliased])
            return STUDIO_THEMES[aliased];
    }
    return STUDIO_THEMES[DEFAULT_THEME_ID];
}
//# sourceMappingURL=index.js.map